import { Box } from '@mui/material';
import SiteHeader from '../Home/DynamicHomepage/components/Landing/SiteHeader';
import RaffleFooter from '../Home/DynamicHomepage/components/NewLayout/RafflePage/RaffleFooter/RaffleFooter';
import { ContactUs } from '../MemberPortal/ContactUs';

// Public contact page — the same ContactUs block used inside the member portal,
// wrapped in the site header (with Log In) and the shared ABN footer.
const ContactPage = () => {
  return (
    <Box
      sx={{
        background: '#070c13',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <SiteHeader />
      <Box
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: 1100,
          mx: 'auto',
          px: { xs: 0, md: 1.5 },
          py: { xs: 2, md: 4 }
        }}
      >
        <ContactUs />
      </Box>
      <RaffleFooter />
    </Box>
  );
};

export default ContactPage;
